import { IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class IndentIdRequest {
    @ApiProperty()
    @IsNotEmpty({ message: "Indent Id should not be empty" })
    @IsNumber()
    indentId: number;

    @ApiProperty()
    grnCompleted?: boolean;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;
}